import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=52c55cf3"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=52c55cf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports